import React, { Component } from 'react'
import { connect } from 'react-redux'
import {

} from "../../../state/ducks/member/index";
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";

import $ from 'jquery';
import { createPaymentPages } from '../../../state/ducks/payment/types';
import AppCustomSelect from '../shared/AppCustomSelect';
import {
    getCustomSelectLabel,
    setCustomSelectFieldState,
} from '../../../utils/customSelect';

function uyeNoKontrol() {
    var uyeNo = getCustomSelectLabel("uyeno");

    var durum = 1;

    if (uyeNo == "Üye Numarası") {
        durum = 0;
        setCustomSelectFieldState("uyeno", true);
        $("#uyeNo_hatamesaj").html("Üye Numarasını Seçmelisiniz");
    } else {
        setCustomSelectFieldState("uyeno", false);
        $("#uyeNo_hatamesaj").html("");
    }
    return durum;
}

function formKontrol() {
    var tarih = $("#tarih").val();
    var ucretLira = $("#ucretLira").val();

    var durum = 1;
    // kuruş alanı boş ise kuruş 00 olduğu kabul edilir. O sebep ile kontrol dışı.

    // Talimat Tarihi Alanı boş mu kontrol
    if (tarih == "") {
        durum = 0; // Konu Boş
        $("#tarih").parent().addClass("t-error");
        $("#tarih").next().html("<i class='t-icon-error text-danger'></i>");
        $("#tarih_hatamesaj").html("Tarih alanı boş bırakılamaz");
    } else {
        $("#tarih").parent().removeClass("t-error");
        $("#tarih").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#tarih_hatamesaj").html("");
    }
    // Açıklama boş mu kontrol
    if (ucretLira == "") {
        durum = 0; // Mesaj Boş
        $("#ucretLira").parent().addClass("t-error");
        $("#ucretKrs").next().html("<i class='t-icon-error text-danger'></i>");
        $("#ucretLira_hatamesaj").html("Mesaj alanı boş bırakılamaz");
    } else {
        $("#ucretLira").parent().removeClass("t-error");
        $("#ucretKrs").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#ucretLira_hatamesaj").html("");
    };
    return durum

}

export class OrderDetailPayTr extends Component {

    state = {
        memberNo: "0",
        startDate: new Date(),
        aylikTutar: "",
        aylikTutarOndalik: 0,
        installmentCount: "",
        getMemberExpense: {}
    }

    onSubmit = e => {
        e.preventDefault();
        const { payment, orderdetail, expenses } = this.props;

        if (formKontrol() == 0 || uyeNoKontrol() == 0) {
            return false;
        }

        if (this.calcPaymentControl(orderdetail.aylikTutar, orderdetail.aylikTutarOndalik, expenses.kalanTutarToplam, payment.paymentSumData)) {
            orderdetail.startDate = this.state.startDate;
            this.props.changePage(createPaymentPages.creditCard, true);
            this.setState(this.state.getMemberExpense = this.props.expenses)
        }
        else {
            return false;
        }

    }
    calcPaymentControl = (girilenTutar, girilenTutarOndalik, orgUcretiKalanToplamBorc, bekleyenTalimatToplamTutar) => {
        let total = (parseFloat(girilenTutar + '.' + girilenTutarOndalik) + parseFloat(bekleyenTalimatToplamTutar));
        if (orgUcretiKalanToplamBorc >= total) {
            return true;
        }
        else {
            $("#talimatInfoDiv").modal('show');
            return false;
        }

    }

    calcTotal = (aylikTutar, aylikTutarOndalik, installmentCount) => {
        if (aylikTutar == "") {
            aylikTutar = 0;
        }
        if (aylikTutarOndalik == "") {
            aylikTutarOndalik = 0;
        }
        if (installmentCount == "") {
            installmentCount = 0;
        }
        return (parseFloat(aylikTutar + '.' + aylikTutarOndalik) * installmentCount);
    }
    processRun(memberNo) {
        if (uyeNoKontrol() == 1) {
            const { payment, orderdetail } = this.props;
            const paymentType = orderdetail.paymentType;
            debugger;
            this.props.getExpense(memberNo, paymentType);
            this.props.getPaymentSummmary(memberNo);
        }
    }

    render() {
        const { payment, orderdetail } = this.props;
        if (!(orderdetail.startDate instanceof Date) && orderdetail.startDate != null) {
            var startDateArr = orderdetail.startDate.split(".");
            var date = new Date(startDateArr[2], startDateArr[1] - 1, startDateArr[0]);
            orderdetail.startDate = date;
            this.setState({ startDate: date })
        }
        return (
            <>

                {/* yesil Alan*/}
                <div className="row" style={{ padding: "3%" }}>
                    <div className="col-12">
                        {/* KUTU 1 */}
                        <div className="row no-gutters t-kutu t-yesilCizgi">
                            <div
                                className="col bosluk backtop"
                                style={{
                                    backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                                }}
                            >
                                {/* içerikler */}
                                {/* Başlık */}
                                <div className="row no-gutters pb-4">
                                    <div clss="col-auto">
                                        <i className="t-icon-wallet  icon" />
                                    </div>
                                    <div className="col d-flex flex-column justify-content-center">
                                        <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                                            Ödeme Talimatı
                                        </div>
                                        <span className="altBaslik">Ödeme Talimatı Verme</span>
                                    </div>
                                </div>
                                <div className="row no-gutters ">
                                    <div className="col-12 pb-1">
                                        <span className="t-icInputTitle pl-3">Üye Numarası</span>
                                    </div>
                                    {/* üye numaranız*/}
                                    <div className="col-12">
                                        <div className="t-icInput">
                                            <div>
                                                <i className="t-icon-user1" />
                                            </div>

                                            <AppCustomSelect
                                                id="uyeno"
                                                value={orderdetail.memberNo}
                                                placeholder="Üye Numarası"
                                                options={[
                                                    { value: "0", label: "Üye Numarası" },
                                                    ...(payment?.paymentActiveMemberNoListData?.map((item) => ({
                                                        value: String(item.id),
                                                        label: item.adi,
                                                    })) || []),
                                                ]}
                                                onChange={(nextValue) => {
                                                    orderdetail.memberNo = nextValue;
                                                    this.state.memberNo = nextValue;
                                                    this.setState({ memberNo: nextValue });
                                                    this.processRun(nextValue);
                                                }}
                                            />
                                            <div />
                                        </div>
                                    </div>
                                    {/* Hata mesajının geleceği alan*/}
                                    <div
                                        className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                        id="uyeNo_hatamesaj"
                                    />
                                    {/* Tarih */}
                                    {/* <div className="col-12 pb-1">
                                        <span className="t-icInputTitle pl-3">Talimat Tarihi</span>
                                    </div>

                                    <div className="col-12 pb-1 m-takvim">


                                        <div className="input-group">
                                            <div className="input-group-prepend" onClick={e => $(".tarih_Start").focus()}>
                                                <span className="input-group-text m-takvimiconhizalama" id="basic-addon2">
                                                    <i className="t-icon-calendar1"></i>
                                                </span>
                                            </div>
                                            <DatePicker className="t-icInput tarih_Start m-datepicker"
                                                id="tarih"
                                                pattern="^\d{1,2}\/\d{1,2}\/\d{4}$"
                                                required
                                                selected={orderdetail.startDate}
                                                value={orderdetail.startDate}
                                                dateFormat="dd.MM.yyyy"
                                                locale="tr"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                minDate={new Date()}
                                                onChange={e => {
                                                    orderdetail.startDate = e;
                                                    this.setState({ startDate: e });

                                                }} />
                                        </div>

                                    </div> */}
                                    {/* KONU Hata mesajının geleceği alan*/}
                                    {/* <div
                                        className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                        id="tarih_hatamesaj"
                                    /> */}
                                    {/* Açıklama*/}
                                    <div className="col-12 pb-1">
                                        <span className="t-icInputTitle pl-3">
                                            {orderdetail.paymentType == 1 ?
                                            <span>Organizasyon ve Peşinat Ücret Talimat Tutarı</span> :
                                            <span>Organizasyon Tutarı</span>
                                            }
                                            
                                        </span>
                                    </div>
                                    <div className="col-12">
                                        <div className="t-icInput">
                                            <div>
                                                <strong>₺</strong>
                                            </div>
                                            <NumberFormat
                                                displayType={"input"}
                                                required
                                                value={orderdetail.aylikTutar}
                                                maxLength="10"
                                                id="ucretLira"
                                                className="sayi inputpara"
                                                decimalSeparator={false}
                                                thousandSeparator="."
                                                thous="true"
                                                onChange={e => {
                                                    orderdetail.aylikTutar = e.target.value.trim().replace(/\./g, "");
                                                    this.setState({ aylikTutar: e.target.value.trim().replace(/\./g, "") });

                                                }} />
                                            <span>,</span>

                                            <NumberFormat
                                                displayType={"input"}
                                                className="sayimax2" style={{ width: "50px" }} required
                                                value={orderdetail.aylikTutarOndalik}
                                                placeholder="00"
                                                maxLength="2"
                                                id="ucretKrs"
                                                allowLeadingZeros={true}
                                                decimalSeparator={false}
                                                allowNegative={false}
                                                onChange={e => {
                                                    orderdetail.aylikTutarOndalik = e.target.value.trim();
                                                    this.setState({ aylikTutarOndalik: e.target.value.trim() });

                                                }} />
                                            <div />
                                        </div>
                                    </div>
                                    {/* Mesaj Hata mesajının geleceği alan*/}
                                    <div
                                        className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                        id="ucret_hatamesaj"
                                    />
                                    {/* Button */}
                                    <div className="col-12 d-flex justify-content-center pb-3">
                                        <button className="t-icButtonYesil" onClick={this.onSubmit}>
                                            <span>Devam</span>
                                            <i className="t-icon-arrow-right2" />
                                        </button>
                                    </div>
                                </div>
                                <div className="row no-gutters pt-4 justify-content-center align-items-start">
                                    {/* cizgi*/}
                                    <div className="col-1 t-cizgiBackgroundKenar" />
                                    {/* 1*/}
                                    <div className="col-auto t-icStepAktif">
                                        <div className="ortala">
                                            <div className="yuvarlak">1</div>
                                        </div>
                                        <span>Ödeme Bilgileri</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-auto t-cizgiBackgroundOrta" />
                                    {/* 2*/}
                                    <div className="col-auto t-icStepPasif">
                                        <div className="ortala">
                                            <div className="yuvarlak">2</div>
                                        </div>
                                        <span>Kart Bilgileri</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-auto t-cizgiBackgroundOrta" />
                                    {/* 2*/}
                                    <div className="col-auto t-icStepPasif">
                                        <div className="ortala">
                                            <div className="yuvarlak">3</div>
                                        </div>
                                        <span>Onay</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-1 t-cizgiBackgroundKenar" />
                                </div>
                                <div className="row no-gutters pt-0 pb-4 justify-content-center align-items-start">
                                    . . .
                                </div>
                                {/* içerikler BİTTİ */}
                            </div>
                            <div className="col-auto renk" />
                        </div>
                        {/* KUTU 1 BİTTİ */}
                    </div>
                </div>
                {/* Duyurlar Baslık*/}
                {/* duyrular Bitti*/}
                <div className="row" style={{ height: 30 }} />
                <div className="modal" id="talimatInfoDiv" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="t-modalAreaMailOrder" id="id-modal" style={{ display: "block" }}>
                        {/* Bu kısım animasyon için Hareket eden kısım. */}
                        <div className="t-modalContentMailOrder" id="id-modalTipi" style={(window.innerWidth <= 900) ? { width: "89%" } : { width: "51%" }}>
                            <div
                                className="t-modalMailOrder"
                                id="id-modalGenel"
                                style={{ backgroundColor: "rgb(255, 255, 255)", boxShadow: "3px 3px 3px #939191" }}
                            >
                                <div className="container-fluid">
                                    {/* Header */}
                                    <div className="row t-modalHeaderMailOrder">
                                        <div
                                            className="col"
                                            id="id-modalHeader"
                                            style={{ color: "rgb(119, 119, 119)" }}
                                        >
                                            TALİMAT TUTARI
                                        </div>
                                        <div className="col-auto t-cursorPointer" data-dismiss="modal">
                                            <i
                                                className="t-icon-cross"
                                                id="id-modalHeaderIcon"
                                                style={{ color: "rgb(119, 119, 119)" }}
                                            />
                                        </div>
                                    </div>
                                    {/* Body */}
                                    <div className="row t-modalBodyMailOrder">
                                        <div
                                            className="col-12"
                                            id="id-modalBody"
                                            style={{ color: "rgb(119, 119, 119)" }}
                                        >
                                            <strong>
                                            {orderdetail.paymentType == 1 ?
                                            <span>Girmiş olduğunuz talimat tutarı, kalan organizasyon toplamından büyük olamaz.</span> :
                                            <span>Girmiş olduğunuz talimat tutarı, kalan organizasyon toplamından büyük olamaz.</span>
                                            }
                                                
                                            </strong>
                                            <br>
                                            </br>
                                            <br>
                                            </br>

                                            <strong style={{ color: "red", fontSize: '12pt' }}>
                                                Lütfen önceden girilen talimatları kontrol ediniz. Başarısız talimat işleminiz var ise iptal edip tekrar talimat girmeyi deneyiniz.
                                            </strong>
                                        </div>
                                    </div>
                                    {/* footer*/}
                                    <div className="row t-modalFooterMailOrder">
                                        <div
                                            className="col-12"
                                            id="id-modalFooter"
                                            style={{ color: "rgb(102, 102, 102)" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
}

function mapStateToProps(state) {

};

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailPayTr);
